<template>
  <div class="content-wrap synergeticOffice  clearfix"><!-- mt22 -->
    <div class="clearfix content_boox">
      <pro-channel></pro-channel>
      <travel-line></travel-line>
      <tourists></tourists>
      <visitor-ratio></visitor-ratio>
      <visitor-age></visitor-age>
      <consumption></consumption>



      <!-- <key-word></key-word> -->
      <!-- <travel></travel> -->





    </div>
  </div>
</template>

<script>
  import visitorRatio from './visitorRatio';
  import visitorAge from './visitorAge';
  import proChannel from './proChannel';
//  import transport from './transport';
  import travel from './travel';
  import travelLine from './travelLine';
  import consumption from './consumption';
  import tourists from './tourists';
  import keyWord from './keyWord';
//  import touristMap from './touristMap';
  export default {
    name: 'marketing',
    components: {
      'visitor-ratio': visitorRatio,
      'visitor-age': visitorAge,
      'pro-channel': proChannel,
//      'transport': transport,
      'travel': travel,
      'travel-line': travelLine,
      'consumption': consumption,
      'tourists': tourists,
      'key-word': keyWord,
//      'tourist-map': touristMap,

    }
  }
</script>

<style >
  /* .marketing{ height:4.4rem;height: 45vh;width: 32.5%;} */
  .marketing{height: 40vh;;width: 32.5%;}
  /* height:3.8rem; */
  .marketing-wrap{height:100%;width: 100%;border-radius: 4px;padding-top: .09rem}
  /* .marketing-inner width: 4.5rem;height: 3.54rem; */
  .marketing-inner{width: 100%;height: 100%;border-radius: 4px;margin: 0 auto;}
  .mtt{margin-top:0.12rem;}
  .content_boox{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    /* padding: 20px; */
  }
  .ml {
      margin-left: 0.8%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/marketing/marketing.vue